module.exports = __webpack_public_path__ + "static/img/m2.35b9d9a0.png";